import { Routes } from '../routes/routes'

const translations: Record<Routes | string, string> = {
  [Routes.Profile]: '/account/profile',
  [Routes.ProfileManagement]: '/account/profile-management',
  [Routes.Accounting]: '/account/accounting',
  [Routes.Transactions]: '/account/transactions',
  [Routes.ArchiveReports]: '/account/archive/reports',
  [Routes.ArchiveNotifications]: '/account/archive/notifications',
  [Routes.Activation]: '/account/activation',
  [Routes.Search]: '/search',
  [Routes.CompanyDetail]: '/company/:companyIdentifier/:slug',
  [Routes.Investigation]: '/investigation',
  [Routes.Cart]: '/cart',
  [Routes.PasswordReset]: '/password-reset',
  [Routes.PasswordUpdate]: '/password-update',
  [Routes.Register]: '/register',
  [Routes.Checkout]: '/checkout',
  [Routes.Billing]: '/checkout/billing',
  [Routes.Payment]: '/checkout/payment',
  [Routes.Confirmation]: '/checkout/confirmation',
  [Routes.OrderProcessing]: '/checkout/:orderId/processing',
  [Routes.UploadImport]: '/import',
  [Routes.Import]: '/import/:importId',
  [Routes.ImportHistory]: '/account/archive/imports',
  [Routes.ArchiveInvoices]: '/account/archive/invoices'
}

export default translations
